/** Decorative shapes in the promo modal header. No behaviour, kept apart to keep the modal markup readable. */
const SHAPE_MODIFIERS = [
    "circle-1",
    "circle-2",
    "circle-3",
    "circle-4",
    "diamond-1",
    "diamond-2",
    "dot-1",
    "dot-2",
] as const;

const ManageReturnsRedesignPromoDecorations: React.FC = () => (
    <div className="manage-returns-redesign-promo-modal__decorations" aria-hidden="true">
        {SHAPE_MODIFIERS.map((modifier) => (
            <span
                key={modifier}
                className={`manage-returns-redesign-promo-modal__shape manage-returns-redesign-promo-modal__shape--${modifier}`}
            />
        ))}
    </div>
);

export default ManageReturnsRedesignPromoDecorations;
